import * as React from "react";
function SvgStarCrossed(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M11.7 29.5L0 18.1l16.1-2.4 7.3-14.6 6 12.2-1.9 1.8-4.2-8.5-5 10.1-.5 1.3-1.2.2-11.2 1.7 8 7.9.8.8-2.8 2.9.3-2zM48 19.4l-11.6-1.7-2.2 2.2 8.5 1.2-8.1 7.9-.9.9.2 1.2 1.9 11.1-10-5.3-1.2-.6-1.1.7-10 5.4.4-2.2-3 3-.6 3.7 14.5-7.6 14.5 7.6-2.8-16.1L48 19.4zM43.7 4.3c-.5-.5-1.3-.5-1.7 0L3.1 44c-.5.5-.5 1.3 0 1.8s1.3.5 1.8 0L43.7 6.1c.5-.5.5-1.3 0-1.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgStarCrossed);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
